import * as React from 'react';
import ScanPlayOutlined from './scan-play-outlined';
import ScanPlayFilled from './scan-play-filled';
import type { IconCombinedProps } from './types';
const ScanPlayCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ScanPlayFilled ref={ref} {...rest} />;
  }
  return <ScanPlayOutlined ref={ref} {...rest} />;
});
export default ScanPlayCombined;